import { Component, OnInit } from '@angular/core';
import { PaymentService } from '../../services/payment.service';

@Component({
standalone: false,
  selector: 'app-last-payment-entry',
  styles: [''],
  template: '',
})
export class LastPaymentEntryComponent implements OnInit {
  constructor(private paymentService: PaymentService) {}

  public ngOnInit(): void {
    this.paymentService.redirectToCurrentPayment().subscribe();
  }
}
